import { apiClient } from '../utils/api';

const pendingActions = new Set();

export async function createVisitor(data) {
    return await apiClient.POST(`api/visitors`, data);
}

export async function updateVisitorAction(visitorId, action, data = {}) {
    if (!visitorId) return Promise.resolve();

    const actionKey = `${visitorId}-${action}-${JSON.stringify(data)}`;

    if (pendingActions.has(actionKey)) {
        return Promise.resolve();
    }

    pendingActions.add(actionKey);

    try {
        const result = await apiClient.PUT(`api/visitors/${visitorId}/action/${action}`, data);
        return result;
    } catch (error) {
        const status = error?.response?.status;
        if (status === 404) {
            // Visitor not found (e.g. record missing, different env, or DB was reset) – tracking is optional
            return Promise.resolve();
        }
        console.error(`Failed to update visitor action ${action}:`, error);
        throw error;
    } finally {
        setTimeout(() => {
            pendingActions.delete(actionKey);
        }, 500);
    }
}
